export const loadImg = (imgUrl = "") => {
  return new Promise(resolve => {
    if (!imgUrl) {
      window.console.error("请传入正确的图片链接")
      resolve(false)
      return
    }
    const img = new Image()
    img.src = imgUrl
    img.onload = () => {
      resolve(true)
    }
    img.onerror = () => {
      resolve(false)
    }
  })
}

export const debounce = (fn, delay = 100) => {
  let timer = null
  return args => {
    if (timer) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn && fn(args)
        clearTimeout(timer)
        timer = null
      }, delay)
    } else {
      timer = setTimeout(() => {
        fn && fn(args)
        clearTimeout(timer)
        timer = null
      }, delay)
    }
  }
}

export const throttle = (fn, delay = 100) => {
  let timer = null
  return args => {
    if (timer) return
    timer = setTimeout(() => {
      fn && fn(args)
      clearTimeout(timer)
      timer = null
    }, delay)
  }
}
